/*@flow*/
import getCompanyId from 'lib/getCompanyId';
import getAssetCompanyId from 'lib/getAssetCompanyId';

export default (): boolean => {
  const assetCompanyId = getAssetCompanyId();
  const myCompanyId = getCompanyId();
  return Boolean(assetCompanyId) && myCompanyId === assetCompanyId;
};
